import React, { useState, useRef, useEffect } from "react";

const OTPModal = ({ onClose, otp, setOtp, isResendDisabled, setIsResendDisabled, inputRefs, handleSubmit, handleResendOTP, handleInputChange, handleKeyDown }) => {
  const [secondsRemaining, setSecondsRemaining] = useState(30); // Set the initial timer duration

  useEffect(() => {
    let timer;
    if (isResendDisabled && secondsRemaining > 0) {
      timer = setInterval(() => {
        setSecondsRemaining((prev) => prev - 1);
      }, 1000);
    } else if (secondsRemaining === 0) {
      setIsResendDisabled(false); // Enable the resend button when the timer reaches 0
    }
    return () => clearInterval(timer); // Cleanup the timer on unmount
  }, [isResendDisabled, secondsRemaining]);

  const handleResendClick = () => {
    handleResendOTP(); // Call the resend OTP function
    setIsResendDisabled(true); // Disable the resend button
    setSecondsRemaining(30); // Reset the timer
  };

  // Handle paste event for OTP
  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text/plain").trim();
    if (/^\d+$/.test(pastedData) && pastedData.length === otp.length) {
      const newOtp = pastedData.split("");
      setOtp(newOtp);
      newOtp.forEach((digit, index) => {
        inputRefs.current[index].value = digit;
      });
      inputRefs.current[otp.length - 1].focus(); // Focus on the last input field
    }
  };


  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm z-50">
      <div className="bg-white rounded-xl p-8 max-w-md w-full shadow-2xl transform transition-all duration-300 ease-in-out z-50">
        <h2 className="text-xl font-bold mb-6 text-center text-gray-800">
          Enter OTP
        </h2>
        <form onSubmit={handleSubmit}>
          <div className="flex justify-center space-x-4 mb-6">
            {otp.map((digit, index) => (
              <input
                key={index}
                type="text"
                value={digit}
                onChange={(e) => handleInputChange(index, e.target.value)}
                onKeyDown={(e) => handleKeyDown(index, e)}
                onPaste={handlePaste} // Add onPaste event handler
                maxLength="1"
                className="w-12 h-12 text-center text-2xl border-2 border-gray-200 rounded-lg focus:ring-4 focus:ring-blue-200 focus:border-blue-500 outline-none transition-all duration-200"
                ref={(el) => (inputRefs.current[index] = el)}
              />
            ))}
          </div>
          <button
            type="submit"
            style={{backgroundColor:"#2e61a2"}}
            className="w-full text-white py-3 rounded-xl transition-all duration-300 shadow-lg hover:shadow-xl"
          >
            Submit
          </button>
          <div className="mt-6 text-center">
            <button
              onClick={handleResendClick}
              disabled={isResendDisabled}
              className={`text-sm text-blue-600 hover:text-blue-800 transition-all duration-200 ${
                isResendDisabled ? "opacity-50 cursor-not-allowed" : ""
              }`}
            >
              Resend OTP {isResendDisabled && `(${secondsRemaining}s)`}
            </button>
          </div>
        </form>
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 transition-all duration-200"
        >
          ✕
        </button>
      </div>
    </div>
  );
};

export default OTPModal;